import React from 'react';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { LegalPage } from './components/LegalPage';
import { Navbar } from './components/Navbar';
import { QualificationErrorBoundary } from './components/QualificationErrorBoundary';
import { QualificationForm } from './components/QualificationForm';
import { Reviews } from './components/Reviews';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  const pathname = window.location.pathname.replace(/\/$/, '') || '/';
  const isPrivacyPage = pathname === '/privacidad';
  const isTermsPage = pathname === '/terminos';
  const isLegalPage = isPrivacyPage || isTermsPage;
  return <div className="min-h-screen bg-black font-sans selection:bg-amber-400/30 selection:text-white" data-id="element-0" data-mp="2wk9y4kb1ymz3">
      <Navbar data-id="element-1" data-mp="28tw62tsgwo4i" />
      {isPrivacyPage ? <LegalPage title="Política de Privacidad" data-id="element-2" data-mp="28suvsrja05nu" /> : isTermsPage ? <LegalPage title="Términos y Condiciones" data-id="element-3" data-mp="23u9uspw79hyc" /> : <main data-id="element-4" data-mp="3ijxsv0nzqion">
          <Hero data-id="element-5" data-mp="3ikh98cxzsz0k" />
          <QualificationErrorBoundary data-id="element-6" data-mp="3iiwfgpji5k3r">
            <QualificationForm data-id="element-7" data-mp="3ihv0wb3a2fha" />
          </QualificationErrorBoundary>
          <Reviews data-id="element-8" data-mp="3mk83iqmq9x9u" />
        </main>}
      <Footer data-id="element-9" data-mp="3rc9f0ac2njyt" />
      {!isLegalPage && <StickyCTA data-id="element-10" data-mp="3rbzo8kj7d8s2" />}
    </div>;
}